/* FE — 时间轴按载体实时切换（artvta，2026-09-12；2026-09-23 补吸底条分支）
 *
 * 为什么需要：snippets/fe-shipping-checkpoints.liquid 在服务端按
 * selected_or_first_available_variant 判断载体，带 ?variant= 直接打开页面时
 * 天数是对的；但 Shrine 在前端切换变体时并不重绘这个 block，Liquid 不会重新
 * 求值，天数会停在页面加载时那一组。本脚本补上前端这一段。
 *
 * 做法：snippet 已把两组天数都写进 checkpoint #2 / #3 的 data-fe-toile 与
 * data-fe-def（格式 "min,max"）。这里监听变体切换，按当前选中的 option 是否
 * 含 "toile" 挑一组写回 data-min-days / data-max-days，再调用 Shrine 自带的
 * <dynamic-dates> 的 insertDates() 重算日期文字。
 *
 * 变体来源（2026-09-23 起三路，任一路先到都行，重复执行无副作用）：
 *   1. document 上 variant-selects 的 change（原有写法）；
 *   2. 吸底条 secondary-variant-select(-separate) 的 change：直接读它自己的 select 值
 *      （combined 模式值为 "option1,option2"）——原写法只认 variant-selects，漏了吸底条；
 *   3. Shrine pubsub PUB_SUB_EVENTS.variantChange（带 variant.options，主选择器与吸底条都会发）。
 *
 * insertDates() 是 Shrine 远程 JS 里的方法（本地 assets 没有源码），已在
 * 线上实测可直接调用并正确重算；调用点加了 try/catch，方法名将来若变化，
 * 页面只会停在服务端渲染的那一组天数，不会报错也不会白屏。
 * subscribe / PUB_SUB_EVENTS 同样是远程 JS 的全局名，不存在就跳过，只靠 change 监听。
 */
(function () {
  'use strict';

  var TOILE_KEYWORD = 'toile';

  function groupOf(text) {
    return (text || '').toLowerCase().indexOf(TOILE_KEYWORD) > -1 ? 'toile' : 'def';
  }

  function currentGroup(scope) {
    var vals = [];
    scope.querySelectorAll('variant-selects input:checked').forEach(function (el) {
      vals.push(el.value || '');
    });
    scope.querySelectorAll('variant-selects select').forEach(function (el) {
      vals.push(el.value || '');
    });
    return groupOf(vals.join(' '));
  }

  // optionsText 可省略：省略时照原写法从主选择器读
  function refresh(scope, optionsText) {
    var group = typeof optionsText === 'string' ? groupOf(optionsText) : currentGroup(scope);
    scope.querySelectorAll('dynamic-dates').forEach(function (dd) {
      var touched = false;
      dd.querySelectorAll('[data-fe-toile][data-fe-def]').forEach(function (p) {
        var pair = (group === 'toile' ? p.dataset.feToile : p.dataset.feDef).split(',');
        if (pair.length !== 2) return;
        if (p.dataset.minDays === pair[0] && p.dataset.maxDays === pair[1]) return;
        p.dataset.minDays = pair[0];
        p.dataset.maxDays = pair[1];
        touched = true;
      });
      if (!touched) return;
      try {
        dd.insertDates();
      } catch (e) {
        /* 方法名变了就保持服务端渲染的那一组，不影响页面其它部分 */
      }
    });
  }

  function stickyOptions(sticky) {
    var combined = sticky.querySelector('select.variant-dropdown');
    if (combined) return combined.value.replace(/,/g, ' ');
    var vals = [];
    sticky.querySelectorAll('select').forEach(function (el) { vals.push(el.value || ''); });
    return vals.join(' ');
  }

  document.addEventListener('change', function (e) {
    var target = e.target;
    if (!target || !target.closest) return;
    var sticky = target.closest('secondary-variant-select, secondary-variant-select-separate');
    if (!sticky && !target.closest('variant-selects')) return;
    var scope = target.closest('product-info') || document;
    // 让 Shrine 自己的变体切换逻辑先跑完
    setTimeout(function () {
      if (sticky) {
        refresh(scope, stickyOptions(sticky));
      } else {
        refresh(scope);
      }
    }, 0);
  });

  try {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var data = (event && event.data) || {};
        var variant = data.variant;
        var scope = (data.sectionId &&
          document.querySelector('product-info[data-section="' + data.sectionId + '"]')) || document;
        setTimeout(function () {
          if (variant && variant.options) {
            refresh(scope, variant.options.join(' '));
          } else {
            refresh(scope);
          }
        }, 0);
      });
    }
  } catch (e) {
    /* pubsub 接口变了就只靠上面的 change 监听 */
  }
})();
